import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Editor.scss";

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { align: [] },
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
  ],
};

const formats = [
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "align",
];

const Editor = ({ answer, onChange }) => {
  return (
    <div>
      <ReactQuill
        defaultValue={answer}
        //   readOnly={loadingExam}
        theme="snow"
        modules={modules}
        formats={formats}
        onChange={onChange}
      />
    </div>
  );
};
export default Editor;
